import { GameLevelEnum } from '@core-http';

export const availableLevels: GameLevelEnum[] = Object.values(GameLevelEnum).filter(
  (level: GameLevelEnum) => level !== GameLevelEnum.PROFESSIONAL
);
